import { OutlookToggleImpl } from "./OutlookToggleImpl";

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Function OutlookToggleImpl called at module scope is not allowed. This may cause unwanted side effects. */
export const OutlookToggle: OutlookToggleImpl = new OutlookToggleImpl();
